<template>
	<div class="brick" style="width:700px;">
		<div class="list_top_box">
			<div class="left_option">
				<CustomDatePicker v-model="login_date" class="mgr_10 mgr_10" />
				<a href="javascript:;" @click="selectToday()" class="gray_bt mgr_15">Today</a>
			</div>
		</div>

		<table class="list_tbl" border="0">
			<thead>
				<tr>
					<th style="width:160px;">Login Date Time</th>
					<th style="width:100px;">User ID</th>
					<th>User Name</th>
					<th style="width:150px;">User Type</th>
					<th style="width:120px;">IP Address</th>
					<th style="width:50px;">From</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(l, index) in logs" v-bind:value="index" v-bind:key="index">
					<td>{{ l.log_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
					<td>{{ l.user_id }}</td>
					<td>{{ l.user_name }}</td>
					<td>{{ l.user_type | userTypeName }}</td>
					<td>{{ l.ip_address }}</td>
					<td class="al_center">{{ l.login_from == 'P' ? 'PC' : l.login_from == 'M' ? 'Mobile' : '' }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { apiSelectLoginLogList } from '@/api/report/report.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today } from '@/utils/date';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',

			login_date: today(),
			logs: [],
		};
	},
	watch: {
		login_date: function() {
			this.search();
		},
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},

	components: {
		CustomDatePicker,
	},
	methods: {
		setDate(day) {
			//console.log(day);
			this.login_date = day;
		},
		isToday(day) {
			return today() == day;
		},
		// viewSchedule(s) {
		// 	this.schedule = s;
		// 	this.mode = 'detail';
		// 	this.modalName = 'Schedule';
		// 	this.showModal = true;
		// },
		// closeModal(returnValue) {
		// 	this.showModal = false;
		// 	if (returnValue) this.search();
		// },
		selectToday() {
			this.login_date = today();
		},
		search() {
			this.selectLoginLogList();
			//console.log(this.selected_date);
		},
		async selectLoginLogList() {
			var param = {
				login_date: this.login_date,
			};

			const { data } = await apiSelectLoginLogList(param);
			//console.log(data);
			this.logs = data.loginLogList;
		},

		async index() {},
		async init() {
			await this.index();
			await this.search();
		},
	},
	created() {
		// if (this.$route.query.dept_code) {
		// 	console.log(this.$route.query.dept_code);
		// 	this.dept_code = this.$route.query.dept_code;
		// }
		//var vm = this;

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_login_log');
		this.$store.commit('setSubTitle', 'Report -> Login Log');

		this.init();
	},
	mounted() {},
};
</script>

<style></style>
